module.exports = __webpack_public_path__ + "static/isaacBig-cd1e896e9e8980d2854bd2cbfbe05493.png";